export default __webpack_public_path__ + "static/media/pic-thanks-feedback.67d02737.svg";